module.exports = __webpack_public_path__ + "static/media/empty_state_graph_graph.5563ac7f.png";